import { memo } from 'react';
import styled from '@emotion/styled';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip';
import { trunc } from '@trinity/chat-components/utils';
import { OpenAddressButton } from './OpenMapsButton';

type Props = {
  city: string;
  state: string;
  zip: string;
  country: string;
  street: string;
  maxAddressLength?: number;
};

export const KolAddress = memo((props: Props) => {

  const address = [props.street, props.city, props.state, props.zip, props.country].filter(Boolean).join(', ');
  const displayAddress = props.maxAddressLength
    ? trunc(address, props.maxAddressLength)
    : address;

  const includeLink = props.street && props.city && props.state && props.zip;
  const hasNoAddress = !props.street && !props.city && !props.state && !props.zip && !props.country;

  if (hasNoAddress) {
    return (
      <PlaceholderText>
        None
      </PlaceholderText>
    );
  }

  if (!includeLink) {
    return (
      <Tooltip
        title={address}
        enterDelay={1000}
        enterNextDelay={500}>
        <div>
          {displayAddress}
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      title={address}
      enterDelay={1000}
      enterNextDelay={500}>
      <OpenAddressButton address={address} />
    </Tooltip>
  );
});

const PlaceholderText = styled.div(({ theme }) => ({
  color: theme.palette.gray.main,
}));